import $ from 'jquery';

$( () => {
  $( '.video-container' ).hover(function() {
      $( this ).find( '.video-overlay' ).fadeOut();
  }, function() {
      $( this ).find( '.video-overlay' ).fadeIn();
  });
});